import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import List from './list';
import Form from './form';

const Component = () => (
  <Switch>
    <Route path="/firmware/add"><Form /></Route>
    <Route path="/firmware/edit/:id"><Form /></Route>
    <Route path="/firmware"><List /></Route>
    <Redirect to="/firmware" />
  </Switch>
);

export default Component;
